const title = $('.animateText');
const text = [
    'innovatieve',
    'creatieve',
    'flexibele',
    'betrokken',
];
const interval = 100;
const pause = 2000;

let count = 0;
let index = 0;

const type = () => {
    if (count === text.length) {
        count = 0;
    }

    let currentText = text[count];
    title.html(currentText.slice(0, index));

    // Loop over words
    if (index < currentText.length) {
        index++;
    } else {
        index = 0;
        count++;
    }

    // Check if the last letter is hit. If so wait
    if (!currentText[index - 1]) {
        setTimeout(type, pause);
    } else {
        setTimeout(type, interval);
    }
}

type();
